export const environment = {
  production: true,
  url: {
    base: 'https://api.x-newgen.com',
    static: 'https://api.x-newgen.com',
    storage: 'https://api.x-newgen.com/uploads',
  },
};
